import { Search, X } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'
import { BILLING_STATUS_FILTERS } from '../constants/billingStatusFilters'

interface BillingFiltersProps {
  status: string
  onStatusChange: (value: string) => void
  search: string
  onSearchChange: (value: string) => void
  fromDate: string
  onFromDateChange: (value: string) => void
  toDate: string
  onToDateChange: (value: string) => void
}

/** Barra de filtros del listado: número de factura, estado y rango de fecha. */
export function BillingFilters({
  status,
  onStatusChange,
  search,
  onSearchChange,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
}: BillingFiltersProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end">
      <div className="w-full sm:max-w-[260px]">
        <label className="mb-1.5 block text-xs font-medium text-ink-muted">Número de factura</label>
        <div className="relative">
          <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-ink-subtle" />
          <input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Ej. F-2026-0612"
            className="h-10 w-full rounded-lg border border-line bg-white py-2 pl-9 pr-9 text-sm text-ink outline-none focus:border-brand"
          />
          {search && (
            <button onClick={() => onSearchChange('')} className="absolute right-2 top-1/2 grid size-6 -translate-y-1/2 place-items-center rounded text-ink-subtle hover:text-ink">
              <X className="size-3.5" />
            </button>
          )}
        </div>
      </div>

      <div className="w-full sm:max-w-[200px]">
        <label className="mb-1.5 block text-xs font-medium text-ink-muted">Estado</label>
        <Select value={status} onValueChange={onStatusChange}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {BILLING_STATUS_FILTERS.map((f) => (
              <SelectItem key={f.value} value={f.value}>
                {f.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <label className="mb-1.5 block text-xs font-medium text-ink-muted">Desde</label>
        <input
          type="date"
          value={fromDate}
          max={toDate || undefined}
          onChange={(e) => onFromDateChange(e.target.value)}
          className="h-10 rounded-lg border border-line bg-white px-3 text-sm text-ink outline-none focus:border-brand"
        />
      </div>

      <div>
        <label className="mb-1.5 block text-xs font-medium text-ink-muted">Hasta</label>
        <input
          type="date"
          value={toDate}
          min={fromDate || undefined}
          onChange={(e) => onToDateChange(e.target.value)}
          className="h-10 rounded-lg border border-line bg-white px-3 text-sm text-ink outline-none focus:border-brand"
        />
      </div>
    </div>
  )
}
